export function isDevEnvironment() {
  const { hostname, href } = window.location;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return true;
  }

  return /dev/i.test(hostname) || /dev/i.test(href);
}
